import { getQuestionnaireResponseScore } from "@common/questionnaireResponseScore";
import { useTranslation } from "@localization/useTranslation";
import { LegalEntityAuditStatus } from "../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import { InternalAssessmentApiRow } from "../InternalAssessments.types";
import { InternalAssessmentReportRow } from "./InternalAssessmentReportTable.types";

// The three report tables show the same recipient rows through different columns, so they share one mapping and
// differ only in which filters they build on top of it.
export function useInternalAssessmentReportRows(assessments: Array<InternalAssessmentApiRow>): Array<InternalAssessmentReportRow> {
    const { translateString, translateDate, translateLegalEntityAuditStatus } = useTranslation();

    return assessments.map((assessment) => ({
        ...assessment,
        assigneeName: assessment.assignee.name,
        statusString: translateLegalEntityAuditStatus(assessment.status.toString()),
        scoreString: getQuestionnaireResponseScore(
            assessment.status === LegalEntityAuditStatus.Submitted,
            assessment.scoreEnabled,
            assessment.score,
            translateString("scoreNotEnabled")
        ),
        reminderSentString: assessment.reminderSent ? translateDate(assessment.reminderSent) : "",
    }));
}
